'use client'

import { motion } from 'framer-motion'
import { ArrowRight, CircleX, Home } from 'lucide-react'
import Input from '@/components/elements/Input'
import { Button } from '@/components/elements/Button'
import { useVerifyResetFlow } from '@/lib/commerce/hooks'

export default function VerifyReset({ vendor }: { vendor: any }) {
  const f = useVerifyResetFlow(vendor)

  if (f.loading) return <div />

  return (
    <div>
      {f.valid ? (
        <>
          <h1 className="text-[36px] sm:text-[40px] font-bold font-gilroy tracking-[-0.025em] leading-[1.05] text-foreground">
            Шинэ нууц үг
          </h1>
          <p className="mt-2 text-[14px] text-foreground/55">Шинэ нууц үгээ тохируулна уу.</p>

          <form onSubmit={f.handleResetPassword} className="mt-7 flex flex-col gap-4">
            <Input label="Шинэ нууц үг" type="password" value={f.password} onChange={(e: any) => f.setPassword(e.target.value)} placeholder="Таны шинэ нууц үг" onKeyDown={f.handleKeyDown} description="8-аас дээш тэмдэгтэй байх ёстой" />
            <Input label="Шинэ нууц үг давтах" type="password" value={f.passwordRep} onChange={(e: any) => f.setPasswordRep(e.target.value)} placeholder="Шинэ нууц үг давтах" onKeyDown={f.handleKeyDown} />
            <Button type="submit" isLoading={f.btnLoading} icon={ArrowRight} iconPosition="right" variant="outline" className="mt-2 w-full h-14 rounded-full! bg-foreground text-cream font-semibold! border-foreground hover:bg-foreground/90 hover:text-cream transition-all" loadingMessage="Шинэчилж байна...">
              Нууц үг хадгалах
            </Button>
          </form>
        </>
      ) : (
        <div className="flex flex-col gap-4 items-center justify-center text-center">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
            <CircleX className="size-20 text-rose-500" />
          </motion.div>
          <motion.div className="text-[20px] font-bold font-gilroy text-foreground" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
            Код хүчингүй болсон байна
          </motion.div>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1 }}>
            <Button onClick={f.goToLogin} icon={Home} variant="outline" className="h-12 rounded-full! bg-foreground text-cream font-semibold! border-foreground hover:bg-foreground/90 hover:text-cream transition-all">
              Нэвтрэх
            </Button>
          </motion.div>
        </div>
      )}
    </div>
  )
}
